import axios from "axios";
import { getWorkWiseAuthToken } from "../../utils/auth";

export const generateAiText = async (aiQuestion) => {
    let response;
    let error;
    try {
        response = await axios.post(
            'https://workw.com/workwapi/api/Ai/GenerateAIResult',
            JSON.stringify(aiQuestion),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${getWorkWiseAuthToken()}`,
                },
            }
        );
    } catch (err) {
        error = err
        if(error?.response?.status === 401){
            error.message = "Authentication failed"
        } else if(error?.response?.data?.message){
            error.message = error.response.data.message
        }
        console.log("ERROR", error)
    }

    const data = response?.data?.data ?? response?.data;

    return {
        status: !!data,
        message: error?.message || "",
        data
    }
}
